import { Link, useLocation } from "react-router-dom";
import { PulseIcon, TrophyIcon } from "@phosphor-icons/react";

export const Header = () => {
  const { pathname } = useLocation();
  const nav = [
    { to: "/", label: "Simulator" },
    { to: "/leaderboard", label: "Leaderboard" },
  ];
  return (
    <header
      className="sticky top-0 z-40 bg-white border-b-2 border-[#0a0a0a]"
      data-testid="app-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <div className="h-9 w-9 bg-[#0a0a0a] flex items-center justify-center">
            <PulseIcon size={20} weight="bold" color="#fff" />
          </div>
          <div className="leading-none">
            <div className="font-head font-black text-lg tracking-tighter">
              CLAIMSCOPE
            </div>
            <div className="label text-[0.6rem] mt-0.5">Analyst Training Sim</div>
          </div>
        </Link>
        <nav className="flex items-center gap-1">
          {nav.map((n) => {
            const active =
              n.to === "/" ? pathname === "/" : pathname.startsWith(n.to);
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={`px-4 py-2 text-sm font-semibold border transition-colors flex items-center gap-2 ${
                  active
                    ? "bg-[#0a0a0a] text-white border-[#0a0a0a]"
                    : "bg-white text-[#171717] border-transparent hover:border-[#0a0a0a]"
                }`}
              >
                {n.label === "Leaderboard" && <TrophyIcon size={16} weight="bold" />}
                {n.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
};
